import { render, staticRenderFns } from "./materLinkCell.vue?vue&type=template&id=006da20e"
import script from "./materLinkCell.vue?vue&type=script&lang=js"
export * from "./materLinkCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports